type ResourceType = 'OIDCCustomPropertyInclusion'

export const RESOURCE_DISPLAY_NAMES = {
  OIDCCustomPropertyInclusion: 'Actions OIDC Configurations',
} as const satisfies Record<ResourceType, string>
